// import { validURL } from 'root/common/util/url';
import env from 'root/common/util/env';

/**
 * 监听页面显示隐藏
 * callback true , 表示显示，false ， 表示隐藏
 */
export function onVisibilityChange(callback) {
    console.log('call native : onVisibilityChange');
    window.zzc.on('visibilitychange', function(res) {
        // 原生插件命名问题。hidden为false，表示进入页面。。。。
        let isShow = res.hidden;
        callback(isShow);
    });
}
/**
 * 设置头部标题
 * @param {*} title
 */
export function setTitle(title) {
    window.zzc.call('base_webviewTitle', {
        title: title,
    });
}

/**
 * 跳转到首页
 */
export function goHome(options = {}) {
    console.log('call native : base_backToHome');
    return new Promise(resolve => {
        let { tabIndex = 'shouye' } = options;
        window.zzc.call('base_backToHome', {
            tabIndex: tabIndex,
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 获取地理位置
 */
export function getLocation(tips = '') {
    console.log('native call : get location');
    return new Promise(resolve => {
        window.zzc.call('base_requestLocation', {
            tips: tips, // 动态权限申请时（如果未授予定位权限）应用弹框的文案，为空时app使用默认的文案（注：iOS无法动态修改权限文案）
            complete: function(res) {
                // 由于 state != 0 没进success , 所以使用complete
                resolve(res);
            },
        });
    });
}

/**
 * 打开导航
 */
export function openLocation(options) {
    console.log('native call : open location');
    console.log(options);
    return new Promise(resolve => {
        window.zzc.call('startNavigate', {
            success: function(res) {
                resolve(res);
            },
            ...options,
        });
    });
}
/**
 * 检查对应的插件方法是否可用
 * @param {} name
 */
export function canUse(name) {
    return !!(window.zzcjsbridge && window.zzcjsbridge[name]);
}

/**
 * 监听 onload 方法 ，有些插件需要load后再调用
 * @param {} callback
 */
export function ready(callback) {
    if (document.readyState === 'complete') {
        setTimeout(() => {
            callback();
        }, 0);
    } else {
        let completed = function() {
            window.removeEventListener('load', completed);
            callback();
        };
        window.addEventListener('load', completed);
    }
}

/**
 * 返回到上一页
 */
export function backToPreviousPage() {
    console.log('native call : to back');
    return new Promise(resolve => {
        window.zzc.call('base_backToPreviousPage', {
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 获取百川授权信息
 * 响应内容：
 * {
 *      "state": 0, // 0表示成功，其他为错误
 *      "message": "",  // 错误原因
 *      "data":{
 *          "nick":"xxx",
 *          "avatarUrl":"xxx",
 *          "openId":"xxx",
 *          "openSid":"xxx"
 *      }
 *  }
 */
export function callTaoBaoLogin() {
    console.log('call native : taoBaoLogin');
    return new Promise(resolve => {
        window.zzc.call('alibc_login', {
            complete: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 检查是否有权限
 */
export function hasPermissions(permissions) {
    return new Promise(resolve => {
        window.zzc.call('native_hasPermissions', {
            permissions: permissions,
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 检查是否有权限
 */
export function requestPermissions(permission) {
    return new Promise(resolve => {
        window.zzc.call('native_requestPermissions', {
            permission: permission,
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 检查是否有权限
 */
export function jumpPermissionSetting() {
    return new Promise(resolve => {
        window.zzc.call('jump_permission_setting', {
            success: function(response) {
                resolve(response);
            },
        });
    });
}
/**
 * 监听城市改变
 */
export function onCityChange(callback) {
    console.log('call native : onCityChange');
    window.zzc.on('cityChangeAction', function(res) {
        callback(res);
    });
}

// android 专用 ， 通知android横向滚动区域的坐标
export function setScrollHorizontalRect(rects) {
    console.log('call native : ui_scrollHorizontalRect');
    return new Promise(resolve => {
        if (canUse('ui_scrollHorizontalRect')) {
            window.zzc.call('ui_scrollHorizontalRect', {
                rects: rects,
                success: function(response) {
                    resolve(response);
                },
            });
        }
    });
}
/*
 * 判断是否安装拼多多
 * @param {*} isIos
 */
export function hasInstallPdd(isIos) {
    return new Promise((resolve, reject) => {
        if (!canUse('base_phoneIsExistApp')) {
            reject('插件不存在->base_phoneIsExistApp');
        }
        window.zzc.call('base_phoneIsExistApp', {
            appName: isIos ? 'pinduoduo://' : 'com.xunmeng.pinduoduo',
            success: function(response) {
                resolve(response.data);
            },
        });
    });
}
/*
 * 判断是否安装淘宝
 * @param {*} isIos
 */
export function hasInstallTaobao(isIos) {
    return new Promise((resolve, reject) => {
        if (!canUse('base_phoneIsExistApp')) {
            reject('插件不存在->base_phoneIsExistApp');
        }
        window.zzc.call('base_phoneIsExistApp', {
            appName: isIos ? 'tbopen://' : 'com.taobao.taobao',
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/*
 * 判断是否安装考拉
 * @param {*} isIos
 */
export function hasInstallKaolaZk(isIos) {
    return new Promise((resolve, reject) => {
        if (!canUse('base_phoneIsExistApp')) {
            reject('插件不存在->base_phoneIsExistApp');
        }
        window.zzc.call('base_phoneIsExistApp', {
            appName: isIos ? 'kaola' : 'com.kaola',
            success(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 扫码
 */
export function scanCode() {
    return new Promise((resolve, reject) => {
        if (!canUse('native_scan')) {
            reject('插件不存在->native_scan');
        }
        // const scanCodeCallback = msg => {
        //     if (validURL(msg)) {
        //         window.location.href = msg;
        //         return;
        //     }
        //     window.ZZCFL.Toast('内容无法识别');
        //     reject();
        // };
        window.zzc.call('native_scan', {
            success: function(respone) {
                if (env.isIos) {
                    resolve(respone.message);
                } else if (env.isAndroid) {
                    resolve(respone.data);
                }
            },
        });
    });
}

/**
 * 添加提醒到系统日历
 */
export function saveContentToCalendar({
    id,
    title,
    content,
    notes,
    startDateTimestamp,
    endDateTimestamp,
    alarmAheadMinute,
    repeatType,
    byDays,
    byMonthDays,
    url,
}) {
    return new Promise((resolve, reject) => {
        if (!canUse('saveContentToCalendar')) {
            reject('插件不存在->native_scan');
        }
        window.zzc.call('saveContentToCalendar', {
            id,
            title,
            content,
            notes,
            startDateTimestamp,
            endDateTimestamp,
            alarmAheadMinute,
            repeatType,
            byDays,
            byMonthDays,
            url,
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 删除系统日历的内容
 */
export function removeContentFromCalendar(id) {
    return new Promise((resolve, reject) => {
        if (!canUse('removeContentFromCalendar')) {
            reject('插件不存在->native_scan');
        }
        window.zzc.call('removeContentFromCalendar', {
            id,
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 检查内容是否在系统日历
 */
export function checkContentInCalendar(id) {
    return new Promise(resolve => {
        window.zzc.call('checkContentInCalendar', {
            id,
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 拉起小程序
 * @param params
 * @returns {Promise<unknown>}
 */
export const openMiniProgram = (params = {}) => {
    return new Promise(resolve => {
        window.zzc.call('openMiniProgram', {
            // appId,
            // path,
            platform: '1', // 可选值（"0":支付宝，"1":微信）
            type: '0', // 小程序版本(0-正式版  1-体验版 2-预览版)
            ...params,
            success: resolve,
        });
    });
};

/**
 * 通知原生更新0元购tab
 */
export function refreshHomeTab() {
    return new Promise((resolve, reject) => {
        if (!canUse('postNotice')) {
            reject('插件不存在->postNotice');
        }
        window.zzc.call('postNotice', {
            noticeName: 'refreshHomeTab',
            data: {},
            success: function(response) {
                resolve(response);
            },
        });
    });
}
